import React, { useState, useEffect, Link } from "react";
import axios from 'axios';
import { alert_error, alert_success } from "../../AppContext.js";
import { useParams } from 'react-router-dom';

const App = () => {
  const { slug_2 } = useParams();
  const [mediaData, set_mediaData] = useState('');
  const id_orders = 123;
  const fetchData = () => {
    axios.get('https://hust.media/img/memory/get_media.php?folder_name=' + slug_2)
      .then((response) => {
        set_mediaData(response.data);
      })
      .catch((error) => {
        alert_error(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4">
      {mediaData ? (
        mediaData.map((media, index) => (
          <div
            key={index}
            className="px-2 border rounded-lg shadow-lg bg-white flex flex-col items-center"
          > <div
            className="mt-2"
          >
              {media.media_type === "image" ? (
                <img
                  src={media.media_show}
                  alt={media.media_name}
                  className="w-full h-auto rounded"
                />
              ) : (
                <video controls className="w-full h-auto rounded">
                  <source src={media.media_show} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
            <div className="flex py-1 items-center justify-between w-full mt-0 px-0">
              <div className="text-xs text-break text-wrap text-gray-600 px-1 break-words">Tên: {media.media_name}</div>
              <a
                href={media.media_source}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="px-1 text-break text-wrap py-0 bg-pink-300 text-black text-xs rounded-lg hover:bg-pink-500 transition no-underline"
              >
                Download 4K 60FPS ko che
              </a>
            </div>
          </div>
        ))
      ) : (<>
        <p>Loading...</p>
      </>)
      }
    </div >
  );
};

export default App;